module.exports = __webpack_public_path__ + "static/desktop/img/header-slogan.5351a873.png";